var _createClass = require("/codebuild/output/src3971/src/s3/01/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/codebuild/output/src3971/src/s3/01/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _possibleConstructorReturn = require("/codebuild/output/src3971/src/s3/01/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/codebuild/output/src3971/src/s3/01/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _inherits = require("/codebuild/output/src3971/src/s3/01/node_modules/@babel/runtime/helpers/inherits.js");
var _wrapNativeSuper = require("/codebuild/output/src3971/src/s3/01/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var InvalidLoanError = /*#__PURE__*/function (_Error) {
  "use strict";

  _inherits(InvalidLoanError, _Error);
  function InvalidLoanError() {
    _classCallCheck(this, InvalidLoanError);
    return _callSuper(this, InvalidLoanError, arguments);
  }
  return _createClass(InvalidLoanError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
module.exports = {
  InvalidLoanError: InvalidLoanError
};